module.exports = __webpack_public_path__ + "img/header.45f896b7.png";